import { defineMessages } from 'react-intl';

export default defineMessages({
    effectiveDate: {
        id: 'tfpa.policychange.views.contact-details.policychange.PolicyChangeEffectiveDate',
        defaultMessage: 'Policy Change Effective Date',
    },
});
